import { SearchTemplateMessages, SearchTemplateMessagesVariables } from './__generated__/SearchTemplateMessages'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query SearchTemplateMessages($input: SearchMessageInputV2!) {
    listSearchMessages: listSearchMessagesV2(input: $input) {
      searchMessages {
        ... on TemplateMessageV2 {
          id
          isFeatured
          attribution
          categoryId
          created
          likes
          message {
            id
            characters
            text
            tags
          }
        }
      }
      nextCursor
    }
  }
`

export const useListTemplateSearch = (variables: SearchTemplateMessagesVariables, skip?: boolean) => {
  return useQuery<SearchTemplateMessages, SearchTemplateMessagesVariables>(QUERY, {
    fetchPolicy: 'cache-and-network',
    variables,
    skip
  })
}
